const CANONICAL_PRODUCTION_ORIGIN = 'https://hotlistcasino.com';

/** Canonical site origin without trailing slash (non-www in production). */
export function getCanonicalSiteOrigin(): string {
  const raw = String(
    process.env.NEXT_PUBLIC_SITE_URL ||
      process.env.SITE_URL ||
      'http://localhost:3000',
  )
    .trim()
    .replace(/\/+$/, '');

  if (raw.includes('hotlistcasino.com')) {
    return CANONICAL_PRODUCTION_ORIGIN;
  }

  try {
    const u = new URL(raw.startsWith('http') ? raw : `https://${raw}`);
    if (u.hostname.startsWith('www.')) {
      u.hostname = u.hostname.slice(4);
    }
    return u.origin;
  } catch {
    return raw
      .replace(/^https?:\/\//i, 'https://')
      .replace(/^https:\/\/www\./i, 'https://')
      .replace(/\/+$/, '');
  }
}

/** Canonical site URL for Next.js metadataBase and SEO helpers. */
export function getCanonicalSiteUrl(): URL {
  return new URL(`${getCanonicalSiteOrigin()}/`);
}

/** Build an absolute URL on the canonical host. */
export function absoluteSiteUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getCanonicalSiteOrigin()}${normalizedPath}`;
}
